var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThemeCover = function SvgThemeCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "themeCover_svg__prefix__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 .5h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#themeCover_svg__prefix__a)",
    stroke: "#39404D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.334 5.167a2.333 2.333 0 012.333-2.334v0a2.333 2.333 0 012.334 2.334v2.11c0 .123-.1.223-.223.223h-2.11a2.333 2.333 0 01-2.334-2.333v0zM2.334 11.833A2.333 2.333 0 014.667 9.5h2.111c.123 0 .223.1.223.222v2.111a2.333 2.333 0 01-2.334 2.333v0a2.333 2.333 0 01-2.333-2.333v0zM9.001 9.722c0-.123.1-.222.222-.222h2.111a2.333 2.333 0 012.334 2.333v0a2.333 2.333 0 01-2.334 2.333v0a2.333 2.333 0 01-2.333-2.333v-2.11zM9.001 5.167a2.333 2.333 0 012.333-2.334v0a2.333 2.333 0 012.334 2.334v0A2.333 2.333 0 0111.334 7.5h-2.11A.222.222 0 019 7.278V5.167z"
  }))));
};
export default SvgThemeCover;